import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars

const propTypes = {
  admin: PropTypes.object,
};


class ViewAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admin: {
        id: 0,
        name: '',
        email: '',
        signupDate: '',
        role: null,
      },
      date: new Date(),
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.admin) {
      this.setState({
        admin: nextProps.admin,
      });
      this.setState({
        date: { date: new Date(nextProps.admin.signupDate) },
      });
    }
  }
  navigateToEdit() {
    browserHistory.push(`/admins/${this.props.admin.id}`);
  }
  handleCancel() {
    browserHistory.push('/admins?page=1');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <div className="float-right">
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Cancel"
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            label="Edit"
            primary
            onClick={this.navigateToEdit}
          />
        </div>
        <br />
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          value={this.state.admin.id}
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.admin.name}
          name="name"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Email"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.admin.email}
          name="email"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Sign Up Date"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.admin.signupDate}
          name="email"
          style={styles.inputStyle}
        />
        <br />
        <SelectField
          value={this.state.admin.role}
          floatingLabelText="Role"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          name="role"
          floatingLabelStyle={styles.floatingLabelStyle}
        >
          <MenuItem value={0} primaryText="Superadmin" />
          <MenuItem value={1} primaryText="Admin" />
          <MenuItem value={2} primaryText="Operator" />
          <MenuItem value={3} primaryText="Fulfillment" />
          <MenuItem value={4} primaryText="Read Only" />
        </SelectField>
      </div>
    );
  }
}

ViewAdmin.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewAdmin.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    admin: state.admins.admin,
  };
}

export default connect(mapStateToProps)(ViewAdmin);



// WEBPACK FOOTER //
// ./src/components/admins/ViewAdmin.js